
export default {
  name: "Footer"
};
